// @ts-ignore
import { isKeycloakRoute, PermissionsProvider } from "@bsp/auth";
import Header from "./components/Header";
import HeaderKeycloak from "./components/HeaderKeycloak";
import { useMemo } from "react";

const AppRouter = () => {
  const isKeycloak = useMemo(() => isKeycloakRoute(), []);

  return (
    <>
      {!isKeycloak && <Header />}
      {isKeycloak && (
        <PermissionsProvider>
          <HeaderKeycloak />
        </PermissionsProvider>
      )}
    </>
  );
};

export default AppRouter;
